export enum GtmEvent {
  VIEW_ITEM = 'view_item',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',
}
